<template>
  <div>
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="800px"
    >
      <v-card>
        <validation-observer
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(save)">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="300"
                  type="card"
                  :loading="loadingForm"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-menu
                        v-model="visitDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        disabled
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="shopMachineVisitOperation.visitDate"
                          >
                            <v-text-field
                              v-model="shopMachineVisitOperation.visitDate"
                              :label="$t('fields.shopMachineVisitOperation.visitDate')"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="shopMachineVisitOperation.visitDate"
                          no-title
                          :locale="$i18n.locale"
                          @input="visitDateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model="shopMachineVisitOperation.appVisitDate"
                        :label="$t('fields.shopMachineVisitOperation.appVisitDate')"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model="shopMachineVisitOperation.createdByUserUserName"
                        :label="$t('fields.shopMachineVisitOperation.createdByUser')"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                    >
                      <v-text-field
                        v-model="shopMachineVisitOperation.modifiedByUserUserName"
                        :label="$t('fields.shopMachineVisitOperation.updatedByUser')"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="shopMachineVisitOperation.isThereRefill"
                      >
                        <v-switch
                          v-model="shopMachineVisitOperation.isThereRefill"
                          class="mx-2"
                          :label="$t('fields.shopMachineVisitOperation.isThereRefill')"
                          :error-messages="errors"
                          :disabled="shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required_if:shopMachineVisitOperation.isThereRefill,true"
                        name="shopMachineVisitOperation.refill"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisitOperation.refill"
                          :label="$t('fields.shopMachineVisitOperation.refill')"
                          :error-messages="errors"
                          :disabled="!shopMachineVisitOperation.isThereRefill || shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="shopMachineVisitOperation.isThereRefund"
                      >
                        <v-switch
                          v-model="shopMachineVisitOperation.isThereRefund"
                          class="mx-2"
                          :label="$t('fields.shopMachineVisitOperation.isThereRefund')"
                          :error-messages="errors"
                          :disabled="shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required_if:shopMachineVisitOperation.isThereRefund,true"
                        name="shopMachineVisitOperation.refund"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisitOperation.refund"
                          :label="$t('fields.shopMachineVisitOperation.refund')"
                          :error-messages="errors"
                          :disabled="!shopMachineVisitOperation.isThereRefund || shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="shopMachineVisitOperation.isThereWithDraw"
                      >
                        <v-switch
                          v-model="shopMachineVisitOperation.isThereWithDraw"
                          class="mx-2"
                          :label="$t('fields.shopMachineVisitOperation.isThereWithDraw')"
                          :error-messages="errors"
                          :disabled="shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required_if:shopMachineVisitOperation.isThereWithDraw,true"
                        name="shopMachineVisitOperation.withdraw"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisitOperation.withdraw"
                          :label="$t('fields.shopMachineVisitOperation.withdraw')"
                          :error-messages="errors"
                          :disabled="!shopMachineVisitOperation.isThereWithDraw || shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="shopMachineVisitOperation.isThereReturnWithDraw"
                      >
                        <v-switch
                          v-model="shopMachineVisitOperation.isThereReturnWithDraw"
                          class="mx-2"
                          :label="$t('fields.shopMachineVisitOperation.isThereReturnWithDraw')"
                          :error-messages="errors"
                          :disabled="shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required_if:shopMachineVisitOperation.isThereReturnWithDraw,true"
                        name="shopMachineVisitOperation.returnWithDraw"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisitOperation.returnWithDraw"
                          :label="$t('fields.shopMachineVisitOperation.returnWithDraw')"
                          :error-messages="errors"
                          :disabled="!shopMachineVisitOperation.isThereReturnWithDraw || shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="shopMachineVisitOperation.isThereDepositToPay"
                      >
                        <v-switch
                          v-model="shopMachineVisitOperation.isThereDepositToPay"
                          class="mx-2"
                          :label="$t('fields.shopMachineVisitOperation.isThereDepositToPay')"
                          :error-messages="errors"
                          :disabled="shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        rules="numeric|required_if:shopMachineVisitOperation.isThereDepositToPay,true"
                        name="shopMachineVisitOperation.depositToPay"
                      >
                        <v-text-field
                          v-model.number="shopMachineVisitOperation.depositToPay"
                          :label="$t('fields.shopMachineVisitOperation.depositToPay')"
                          :error-messages="errors"
                          :disabled="!shopMachineVisitOperation.isThereDepositToPay || shopMachineVisitOperation.type === 'S'"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-skeleton-loader>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="warning"
                depressed
                rounded
                @click="close"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                color="info"
                depressed
                rounded
                type="submit"
                :loading="loadingSave"
              >
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </div>
</template>

<script>
  import filters from '@/common/filters'
  import dateUtils from '@/common/dateUtils'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const shopMachineVisitOperationsRespository = repositoryFactory.get('shopMachineVisitOperations')

  export default {
    name: 'ShopMachineVisitNoteDialog',
    mixins: [filters],
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      shopMachineVisitOperationId: {
        type: String,
        default: '',
      },
      method: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      showErrorMessage: false,
      errorMessage: '',
      showDialog: false,
      loadingForm: false,
      visitDateMenu: false,
      loadingSave: false,
      shopMachineVisitOperation: {
        visitDate: new Date().toISOString().substr(0, 10),
      },
      shopMachineVisitOperationDefault: {
        visitDate: new Date().toISOString().substr(0, 10),
      },
    }),
    computed: {
      formTitle () {
        return this.method === 'add' ? this.$t('add-visit') : this.$t('edit-visit')
      },
    },
    watch: {
      show (val) {
        this.showDialog = val
        if (val === true) {
          this.fetchData()
        }
      },
    },
    methods: {
      fetchData () {
        var self = this
        self.loadingForm = true
        var id = this.shopMachineVisitOperationId
        shopMachineVisitOperationsRespository.getById(id).then(response => {
          self.shopMachineVisitOperation = Object.assign({}, response.data.data)
          self.shopMachineVisitOperation.visitDate = dateUtils.formatLongDate(self.shopMachineVisitOperation.visitDate)
          self.shopMachineVisitOperation.appVisitDate = dateUtils.formatLongDate(self.shopMachineVisitOperation.appVisitDate)
          self.loadingForm = false
        }).catch(err => {
          self.loadingForm = false
          alert(err)
        })
      },

      close () {
        this.$emit('change-edit-dialog', false)
        this.showDialog = false
        this.$nextTick(() => {
          this.shopMachineVisitOperation = Object.assign({}, this.shopMachineVisitOperationDefault)
        })
      },

      save () {
        if (this.method === 'edit') {
          var self = this
          var data = {
            data: Object.assign(self.shopMachineVisitOperation),
            userId: self.$store.state.user.id,
          }
          data.data.visitDate = dateUtils.formatLongDate(data.data.visitDate)
          data.data.appVisitDate = dateUtils.formatLongDate(data.data.appVisitDate)

          self.loadingSave = true
          shopMachineVisitOperationsRespository.updateShopMachineVisitOperation(data, self.shopMachineVisitOperation.id).then(response => {
            if (response.data.isValid) {
              this.close()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        } else {
          this.items.push(this.shopMachineVisitOperation)
        }
      },
    },
  }
</script>
